var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m203.52 600c0 218.64 177.84 396.48 396.6 396.48 218.52 0 396.48-177.84 396.48-396.48s-177.84-396.48-396.48-396.48c-218.76 0-396.6 177.84-396.6 396.48zm396.48-332.88c183.6 0 332.88 149.28 332.88 332.88s-149.28 332.88-332.76 332.88c-183.72 0-333-149.28-333-332.88s149.28-332.88 332.88-332.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.56 857.64c22.32 0 40.32-18 40.32-40.32 0-22.199-18-40.32-40.32-40.32-22.32 0-40.199 18-40.199 40.32 0 22.32 17.879 40.32 40.199 40.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.8 356.76h63.602v360h-63.602z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.46ed4fdca32b4b94ee355a31a53297ec.svg";
export { ForwardRef as ReactComponent };